import styled from 'styled-components';

export const Row = styled.div.withConfig({
  shouldForwardProp: (prop, defaultCB) => (
    !['wrap', 'gap'].includes(prop)
    && defaultCB(prop)
  ),
})`
  display: flex;
  flex-direction: row;
  flex-wrap: ${({ wrap }) => wrap || 'nowrap'};
  ${({ gap }) => gap ? `gap: ${gap};` : ''}
`;
